var _rect, _g, _path, _rect2, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEduBayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52.003mm",
    height: "19.008mm",
    viewBox: "0 0 52.003 19.008",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.96 -144.14)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.96,
    y: 144.14,
    width: 52.003,
    height: 19.008,
    ry: 3.119,
    fill: "#3b69a5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-251.09 -172.73)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.7 165.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.49 163.82v-2.4508h2.4371c0.84888 0 1.3692 0.35598 1.3692 1.1501 0 0.73935-0.52028 1.3007-1.3965 1.3007zm2.2865-5.9695c0.88995 0 1.2596 0.28752 1.2596 0.98579 0 0.64351-0.39705 0.9858-1.1501 0.9858h-2.396v-1.9716zm-0.0274 7.5167c2.2865 0 3.3955-1.0542 3.3955-2.7109 0-1.3007-0.61612-1.9168-1.3828-2.2044 0.62982-0.26014 1.109-0.91734 1.109-1.6978 0-1.5198-0.95841-2.4782-2.7383-2.4782h-4.4772v9.0912z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.5 163.21c0 0.88995-0.58873 1.4513-1.2322 1.4513-0.93102 0-1.3965-0.4929-1.3965-1.287h-1.6567c0 1.7388 0.99948 2.8205 2.9711 2.8205 1.7251 0 3.0943-1.109 3.0943-3.0122v-6.9142h-1.7799v4.1075c0 0.72565-0.56135 1.2596-1.3692 1.2596-0.75303 0-1.1364-0.42444-1.1364-1.2596v-4.1075h-1.7799v4.3676c0 1.4787 1.0542 2.4371 2.4645 2.4371 0.83518 0 1.5745-0.35598 1.821-0.95841z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.33 326.21c-0.0137 0.79412-0.69828 1.465-1.6156 1.465-0.56136 0-0.86257-0.24645-0.86257-0.75304 0-0.57505 0.3286-0.86257 1.3418-1.0543 0.6572-0.12322 0.97211-0.21906 1.1501-0.39705zm1.7936 2.5603v-4.2581c0-1.6978-0.73935-2.6562-2.8752-2.6562-2.1633 0-2.93 0.9721-2.9574 2.3686h1.6567c0.0821-0.60243 0.41075-0.99948 1.2186-0.99948 0.69827 0 1.1364 0.26014 1.1364 0.69827 0 0.46551-0.24645 0.6435-1.1364 0.76673-1.7936 0.24645-3.0943 0.46551-3.0943 2.4097 0 1.0953 0.71196 1.8484 2.2454 1.8484 0.90365 0 1.6156-0.3149 2.04-0.78042 0.0137 0.20538 0.0548 0.43813 0.10953 0.60243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.02 330.95v-1.6156h-5.0522v-2.3413h4.4498v-1.6019h-4.4498v-1.9442h4.8331v-1.5882h-6.6815v9.0912z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.08 321.69v3.2237c-0.50659-0.71196-1.1637-1.0542-1.9988-1.0542-1.7388 0-2.7657 1.4373-2.7657 3.4773 0 2.2728 1.2183 3.6148 2.9161 3.6148 0.8215 0 1.4514-0.31484 1.8759-0.99942l0.0139 0.99942h1.711v-8.5257zm2.5332 1.6738v5.1094c0 1.4787 0.94438 2.4784 2.2862 2.4784 0.93102 0 1.6294-0.3562 2.095-1.1229v1.1229h1.6841v-7.2717h-0.37517l-1.3911 0.58394v3.6621c0 0.88995-0.47922 1.5332-1.3829 1.5332-0.75304 0-1.1364-0.41047-1.1364-1.2594v-4.0888zm-3.9569 2.0155c0.98579 0 1.4924 0.72556 1.4924 2.1906 0 1.1364-0.65749 1.9306-1.5064 1.9306-0.88996 0-1.5198-0.83531-1.5198-2.0402 0-1.3829 0.49319-2.081 1.5338-2.081z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.30538 0 0 .30538 334.1 265.84)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m589.1 705.12-25.061 10.521c-6.9939 2.9361-18.256 2.9361-25.25 0l-25.01-10.5v16.644c-0.0302 0.18066-0.0302 0.36223 0 0.54297v0.0176h4e-3c0.15949 0.96548 1.1192 1.913 2.8848 2.6543l27.764 11.656c3.8821 1.6299 10.134 1.6299 14.016 0l27.764-11.656c1.7656-0.74127 2.7252-1.6888 2.8848-2.6543h4e-3v-0.0176c0.0302-0.18066 0.0302-0.36223 0-0.54297z",
    fill: "#15253a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.3441
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.86 30.93)",
    strokeWidth: 3.2746
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.92204 -.38708 .92204 .38708 0 0)",
    x: -159.28,
    y: 229.1,
    width: 21.598,
    height: 21.598,
    ry: 3.6226,
    fill: "#15253a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3604
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#cc5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.993 149.33a0.49229 0.49229 0 0 0-0.64649 0.26283 0.49229 0.49229 0 0 0 0.25751 0.6465l10.738 4.5966v4.5747a0.49229 0.49229 0 0 0 0.4876 0.49308 0.49229 0.49229 0 0 0 0.49308-0.49308v-4.898a0.49234 0.49234 0 0 0-0.29585-0.45475z",
    color: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2746,
    style: {
      InkscapeStroke: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.833,
    cy: 161.24,
    r: 1.8276
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m94.005 168.97c0-1.0094 0.81825-7.615 1.8276-7.615 1.0094 0 1.8276 6.6057 1.8276 7.615-4.1e-5 1.0093-0.81826 1.8276-1.8276 1.8276-1.0093 0-1.8276-0.81823-1.8276-1.8276z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1494
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBayLogo);
export default __webpack_public_path__ + "static/media/EduBay_logo.5874850f23d9e08b7c0fa8da518e1878.svg";
export { ForwardRef as ReactComponent };